interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: 'website' | 'article';
}

export function generateSEOData({
  title,
  description,
  keywords = '黄游下戟,黄游下戟典故,黄游下戟出处,黄游下戟寓意,古代典故文化,历史成语典故,中国古典文化意象',
  canonicalUrl = '/',
  ogTitle,
  ogDescription,
  ogType = 'website',
}: SEOHeadProps) {
  const fullTitle = `${title} | 黄游下戟文化研究`;
  const siteUrl = 'https://huangyouxiaji.com';

  return {
    title: fullTitle,
    description,
    keywords,
    canonicalUrl: `${siteUrl}${canonicalUrl}`,
    ogTitle: ogTitle || fullTitle,
    ogDescription: ogDescription || description,
    ogType,
  };
}